"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.997.006A7.997 7.997 0 0 0 0 8.003c0 .135.01.269.019.402l.008.123h1l-.003-.034A6.527 6.527 0 0 1 1 8.003a7.005 7.005 0 0 1 6.997-6.997 7.005 7.005 0 0 1 6.997 6.997c0 3.857-3.139 6.996-6.997 6.996-3.363 0-6.177-2.386-6.845-5.553H.138c.68 3.727 3.937 6.553 7.859 6.553a7.996 7.996 0 1 0 0-15.993Zm2.588 6.666c0-1.378-1.122-2.5-2.5-2.5a2.503 2.503 0 0 0-2.5 2.5h1c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5a.5.5 0 0 0-.5.5v2.074h1V9.121c1.14-.232 2-1.242 2-2.449Zm-3.082 5.35a.6.6 0 1 1 1.202 0 .6.6 0 0 1-1.202 0Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12c0 .216.015.428.03.64l.01.15h1.125l-.003-.052A9.495 9.495 0 0 1 1.125 12C1.125 6.004 6.004 1.125 12 1.125c5.997 0 10.875 4.879 10.875 10.875 0 5.997-4.878 10.875-10.875 10.875-5.255 0-9.65-3.746-10.657-8.708H.206C1.226 19.759 6.112 24 12 24c6.628 0 12-5.373 12-12S18.628 0 12 0Zm3.85 9.133a3.75 3.75 0 0 0-3.745-3.747 3.75 3.75 0 0 0-3.747 3.747h1.125a2.625 2.625 0 0 1 2.621-2.622 2.624 2.624 0 0 1 2.622 2.622 2.625 2.625 0 0 1-2.622 2.622.563.563 0 0 0-.562.562v3.302h1.125v-2.782a3.751 3.751 0 0 0 3.184-3.704Zm-3.716 9.328a.81.81 0 1 1 0-1.62.81.81 0 0 1 0 1.62Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 0C7.164 0 0 7.164 0 16c0 .288.02.57.04.854l.013.199h1.501l-.005-.069A13.126 13.126 0 0 1 1.5 16C1.5 8.005 8.005 1.5 16 1.5c7.996 0 14.5 6.505 14.5 14.5 0 7.996-6.504 14.5-14.5 14.5-7.006 0-12.866-4.995-14.209-11.611H.274C1.636 26.345 8.151 32 16 32c8.837 0 16-7.164 16-16S24.837 0 16 0Zm5.134 12.177a5.001 5.001 0 0 0-4.995-4.995 5.001 5.001 0 0 0-4.996 4.995h1.5a3.5 3.5 0 0 1 3.496-3.495 3.5 3.5 0 0 1 3.495 3.495 3.5 3.5 0 0 1-3.495 3.496.75.75 0 0 0-.75.75v4.403h1.5v-3.71a5.002 5.002 0 0 0 4.245-4.94Zm-4.956 12.437a1.08 1.08 0 1 1 0-2.16 1.08 1.08 0 0 1 0 2.16Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24 0C10.745 0 0 10.745 0 24c0 .139.005.276.01.413l.006.206H1.89A13.017 13.017 0 0 1 1.875 24C1.875 11.8 11.8 1.875 24 1.875S46.125 11.8 46.125 24 36.2 46.125 24 46.125c-11.053 0-20.24-8.147-21.869-18.752H.241C1.88 39.03 11.89 48 24 48c13.255 0 24-10.745 24-24S37.255 0 24 0Zm7.181 18.52A7.19 7.19 0 0 0 24 11.338c-3.96 0-7.181 3.222-7.181 7.182h1.875A5.312 5.312 0 0 1 24 13.213a5.312 5.312 0 0 1 5.306 5.307A5.312 5.312 0 0 1 24 23.826a.937.937 0 0 0-.938.937v6.477h1.875v-5.6c3.519-.46 6.244-3.478 6.244-7.12ZM24.058 35.8a1.327 1.327 0 1 1-.001-2.653 1.327 1.327 0 0 1 0 2.654Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32 0C14.327 0 0 14.327 0 32c0 .185.006.368.012.55.004.092.007.183.009.275h2.5a44.31 44.31 0 0 0-.007-.23A16.65 16.65 0 0 1 2.5 32C2.5 15.734 15.733 2.5 32 2.5c16.266 0 29.5 13.234 29.5 29.5 0 16.267-13.234 29.5-29.5 29.5-14.738 0-26.986-10.863-29.158-25.002H.321C2.508 52.04 15.854 64 32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0Zm9.575 24.693c0-5.28-4.295-9.575-9.575-9.575-5.28 0-9.575 4.295-9.575 9.575h2.5A7.083 7.083 0 0 1 32 17.618a7.083 7.083 0 0 1 7.075 7.075A7.083 7.083 0 0 1 32 31.768c-.691 0-1.25.56-1.25 1.25v8.635h2.5v-7.466c4.69-.614 8.325-4.638 8.325-9.494Zm-9.498 23.041a1.77 1.77 0 1 1-.001-3.539 1.77 1.77 0 0 1 .001 3.54Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconQuestionCircle = function IconQuestionCircle(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Question Circle' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "QuestionCircle"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconQuestionCircle.sizes = [16, 24, 32, 48, 64];
IconQuestionCircle.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconQuestionCircle;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/QuestionCircle.js
// module id = 1829
// module chunks = 0